import { DEFAULT_ERROR_MESSAGE } from '../../constants/messages';
import { ICreateConsultingRequestRequest } from '../../repositories/newbuilding-flat-view-order/v1/create-consulting-request';
import { createConsultingRequest } from '../../services/consultingRequest';
import { TThunkAction } from '../../types/redux/thunk';
import { createError } from '../../utils/notification';
import { pushNotification } from '../notifications';
import { setRequestFailure, setRequestSubmitting, setRequestSuccess } from '../pageState';

export const createConsultingRequestAction = (
  parameters: ICreateConsultingRequestRequest,
): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(setRequestSubmitting());

    try {
      await createConsultingRequest({ httpApi, parameters });

      dispatch(setRequestSuccess());
    } catch (ex) {
      logger.error(ex, {
        domain: 'actions/consultingRequest/createConsultingRequestAction',
      });

      dispatch(pushNotification(createError(DEFAULT_ERROR_MESSAGE)));
      dispatch(setRequestFailure());

      throw ex;
    }
  };
};
